exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category-pills__list{align-content:space-between;display:flex;flex-wrap:wrap;margin-bottom:5px;margin-top:5px}.category-pills__item{display:block;padding-bottom:8px;padding-left:8px}@media print{.category-pills{display:none}}\n", ""]);

// exports
exports.locals = {
	"category-pills__list": "category-pills__list",
	"category-pills__item": "category-pills__item",
	"category-pills": "category-pills"
};